/**
 * Ryan O'Dowd
 * 2023-07-14
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, isDarkMode, positionRelative, absoluteTop, absoluteRight, badgeSize}) => {
  return {
    container: {
      position: positionRelative ? 'relative' : 'absolute',
      top: positionRelative ? null : (absoluteTop || -8),
      right: positionRelative ? null : (absoluteRight || 0),
    },
    titleWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginBottom: 8,
      gap: 8,
    },
    dialogTitle: { // @TODO: combine with other dialogs
      color: isDarkMode ? colors.white : colors.black,
      fontSize: globalScale * 22,
      fontFamily: fonts.primaryBold,
    },
    nextButton: {
      display: 'flex',
      flexDirection: 'row',
    },
    nextButtonContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      justifySelf: 'center',
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    nextButtonContent: {
      flexDirection: 'row-reverse',
    },
    passageWrapper: {
      backgroundColor: isDarkMode ? colors.primaryDark : colors.primary,
      borderColor: isDarkMode ? colors.primary : colors.primaryLight,
      borderWidth: 4,
      borderRadius: 12,
    },
    badge: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: globalScale * badgeSize,
      height: globalScale * badgeSize,
      borderRadius: globalScale * (badgeSize / 2),
      borderColor: colors.white,
      borderWidth: globalScale * 1,
      backgroundColor: colors.alert,
    },
    pausedBadge: {
      backgroundColor: colors.primaryLight,
      borderColor: colors.white,
    },
    pausedBadgeText: {
      color: colors.white,
    },
    otherTranslationPauseBadge: {
      borderWidth: 1,
      borderColor: colors.lightGray,
      backgroundColor: isDarkMode ? colors.primaryDark : colors.primary,
    },
    otherTranslationBadge: {
      backgroundColor: isDarkMode ? colors.primaryDark : colors.primary,
      borderColor: colors.lightGray,
    },
    otherTranslationBadgeText: {
      color: colors.lightGray,
    },
    closedBadge: {
      backgroundColor: colors.gray,
      borderColor: colors.white,
    },
    completedBadge: {
      backgroundColor: colors.accent,
      borderColor: colors.primaryExtraDark,
    },
    badgeText: {
      color: colors.white,
      fontSize: globalScale * 14,
      fontFamily: fonts.primaryBold,
    },
    completedBadgeText: {
      color: colors.primaryExtraDark,
    },
    closedBadgeText: {
      color: colors.white,
    },
    pauseIconWrapper: {
      position: 'absolute',
      top: globalScale * -6,
      right: globalScale * -6,
      width: globalScale * 16,
      height: globalScale * 16,
      borderRadius: globalScale * 8,
      borderWidth: 1,
      borderColor: colors.white,
      backgroundColor: colors.lightGray,
    },
    pauseIcon: {
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: globalScale * 1,
      fontSize: globalScale * 12,
      color: colors.white,
    },
    otherTranslationBadgeIcon: {
      color: colors.lightGray,
    },
    verseText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      flexWrap: 'wrap',
    },
    metadataRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 8,
    },
    metadataText: {
      fontSize: globalScale * 14,
      fontFamily: fonts.primaryBold,
      color: isDarkMode ? colors.white : colors.primaryExtraDark,
    },
    titleText: {
      fontSize: globalScale * 14,
      color: isDarkMode ? colors.white : colors.primaryExtraDark,
      fontFamily: fonts.primary,
    },
    pauseNote: {
      fontSize: globalScale * 14,
      marginTop: globalScale * 16,
    },
    pausedStatus: {
      fontFamily: fonts.primaryBold,
    },
    spacer: {
      flex: 1,
    },
    actionIconButton: {
      display: 'flex',
      // @TODO: marginRight: 8,
      alignSelf: 'center',
      justifySelf: 'center',
    },
    testNowButton: {
      alignSelf: 'center',
      justifySelf: 'center',
    },
  };
};

export default getStyles;
